// Export the Component Definition for use in Contentful Studio
export {UnitCarouselContentfulComponentDefinition} from './UnitCarouselContentfulDefinition';
export type {CourseUnitEntry, UnitCarouselProps} from './UnitCarousel';
export {default} from './UnitCarousel';
